import React, { useEffect, useState } from "react";
import Healthcare from "./Healthcare";
import "./Zakat.css";
import { Link } from "react-router-dom";
const Zakat = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      {/* <div>
                <div class="wrapper" id="cover">
                    <img
                        src={require("../../../Assets/images/zakat-cover2.png")}
                        class="prx"
                        style={{ height: "250px", width: "100%" }}
                    />
                    <h1>Prayer</h1>
                </div>
            </div> */}
      <section class="u-section-2">
        <div class="u-palette-1-base  u-shape-1"></div>
        <div class="u-layout-wrap-1">
          <div>
            <div class="u-layout-row">
              <div class="u-size-31">
                <div class="u-layout-col">
                  <div>
                    <div class="u-container-layout">
                      <img
                        src={require("../../../Assets/images/charity-1.jpg")}
                        alt=""
                        class="u-image u-image-default u-image-1"
                        data-image-width="626"
                        data-image-height="417"
                      />
                      <img
                        src={require("../../../Assets/images/charity-2.jpg")}
                        alt=""
                        class="u-align-left u-image u-image-2"
                        data-image-width="800"
                        data-image-height="568"
                      />
                    </div>
                  </div>
                  <div class="u-container-style u-layout-cell u-left-cell u-size-30 u-layout-cell-2">
                    <div class="u-container-layout">
                      <img
                        src={require("../../../Assets/images/charity-3.jpg")}
                        alt=""
                        class="u-align-left u-image u-image-3"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="u-size-29">
                <div class="u-layout-col">
                  <div>
                    <div class="u-container-layout u-valign-middle u-container-layout-3">
                      <h1 class="u-custom-font u-font-roboto-slab u-text u-text-palette-2-base u-text-1">
                        {rtl
                          ? ` الصدقات (زكاة)`
                          : fr
                          ? "CHARITÉ "
                          : `Alms-giving`}
                        <br />
                        {rtl ? `` : fr ? "(ZAKAT)" : `(zakat)`}
                      </h1>
                      <p class="u-text u-text-2">
                        {rtl
                          ? `مكة والمدينة القابضة هي أول شركة إسلامية في جميع أنحاء العالم تقع في بريطانيا
العظمى ، ولتكون لاعبا رئيسيا في التمويل الإسلامي في العالم بأسره. هذا مصطلح تمويل
إسلامي يشير إلى الالتزام الذي يقع على عاتق الفرد بالتبرع بنسبة معينة من الثروة كل عام
لأسباب خيرية مثل:`
                          : fr
                          ? `MMH est le premier holding islamique au monde situé en
                          Grande-Bretagne et est en passe de devenir un acteur majeur de la
                          finance islamique dans le monde entier :`
                          : ` MMH is the first Islamic
                                                holdings worldwide located in
                                                Great Britain, and to be a major
                                                player in Islamic Finance in the
                                                whole world .This is an Islamic
                                                finance term referring to the
                                                obligation that an individual
                                                has to donate a certain
                                                proportion of wealth each year
                                                to charitable causes like:`}
                      </p>
                      <ul>
                        <li>
                          {rtl
                            ? `خدمة المجتمع (التبرع...)`
                            : fr
                            ? "Le service communautaire (don...)"
                            : `Community service (
                                                    donation…)`}
                        </li>
                        <li>
                          {rtl
                            ? `رعاية خاصة للأطفال`
                            : fr
                            ? "Soins spéciaux aux enfants"
                            : `Special child care`}
                        </li>
                        <li>
                          {rtl
                            ? `دروس القرآن الكريم`
                            : fr
                            ? "Cours de Coran"
                            : `Quran classes`}
                        </li>
                        <li>
                          {rtl
                            ? `ترقيات المباني`
                            : fr
                            ? "Amélioration de bâtiments"
                            : `Building upgrades`}
                        </li>
                        <li>
                          {rtl
                            ? `إطعام الجياع`
                            : fr
                            ? "Nourrir les affamés"
                            : `Feed Hungry`}
                        </li>
                        <li>
                          {rtl
                            ? `منازل للمشردين`
                            : fr
                            ? "Maisons pour les sans-abri"
                            : `Houses For Homeless`}
                        </li>
                        <li>
                          {rtl
                            ? `منح المأوى منازل`
                            : fr
                            ? "Donner des maisons d'hébergement"
                            : `Give Shelter Homes`}
                        </li>
                        <li>
                          {rtl
                            ? `الأيتام...`
                            : fr
                            ? "Soutien aux orphelins..."
                            : `Orphans support…`}
                        </li>
                      </ul>
                      <p>
                        {rtl
                          ? `أولئك الذين (في الأعمال الخيرية و الصدقة) ينفقون من خيراتهم ليلا ونهارا، سرا وعلانية،
لهم مكافأتهم مع ربهم.`
                          : fr
                          ? `Ceux qui (en charité) dépensent de leurs biens la nuit et le jour, en
                          secret et en public, ont leur récompense auprès de leur Seigneur.`
                          : `Those who (in charity) spend of
                                                their goods by night and by day,
                                                in secret and in public, have
                                                their reward with their Lord.`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="bg-zakat-education">
        <div class="zakat-fbloc">
          <h1>
            {rtl
              ? `مؤسسات مكة والمدينة القابضة الخيرية`
              : fr
              ? "FONDATIONS CHARITATIVES MMH"
              : `MMH Charitable foundations`}
          </h1>
          {rtl ? (
            <p>
              ستوفر مؤسسات مكة والمدينة القابضة الخيرية طريقة للمانحين سواء
              كانوا أفرادا أو عائلات أو شركات لإنشاء نهج استراتيجي لأعمالهم
              الخيرية من أجل إحداث تأثير حقيقي على المجتمع. بالإضافة إلى
              الاستفادة من القضية التي اختاروها ، ستوفر مؤسسات مكة والمدينة
              القابضة الخيرية أيضا مزايا مختلفة للمانحين.
              <br /> من خلال بوابة أفريقيا والشرق الأوسط وآسيا ، سنستثمر في نظام
              التعليم والرعاية الصحية ...
            </p>
          ) : fr ? (
            <p>
              Les fondations de charité MMH permettront aux donateurs, qu'il
              s'agisse d'individus, de familles ou d'entreprises, de créer une
              approche stratégique de leur philanthropie afin d'avoir un impact
              réel sur la société. En plus de bénéficier à la cause qu'ils ont
              choisie, les fondations de charité MMH offrent également divers
              avantages aux donateurs.
              <br />
              Par la porte d'entrée vers l'Afrique, le Moyen-Orient et l'Asie,
              nous investirons dans le système éducatif, les soins de santé...
            </p>
          ) : (
            <p>
              MMH Charitable foundations will provide a way for donors whether
              individuals, families, or businesses to create a strategic
              approach to their philanthropy in order to make a real impact on
              society. As well as benefitting their chosen cause, MMH charitable
              foundations also will provide various advantages to the donors.{" "}
              <br />
              By the gateway to Africa, Middle East and Asia we will invest in
              education system, healthcare…
            </p>
          )}
        </div>
        <h1 id="zakat-title">
          {rtl ? `التعليم` : fr ? "ÉDUCATION" : `Education`}
        </h1>
        <div class="edu-bloc">
          <div class="edu-card">
            <p>
              {rtl
                ? `في حين أن دراسة الإسلام لا
تزال في جوهرها ، فإن النظام
التعليمي الحديث يوفر أيضا
تعليما جيدا في مختلف مجالات
الفنون والعلوم. ويساعد هذا
التنوع جميع البلدان على إعداد
مواطنيها للحياة والعمل في
اقتصاد عالمي. سنبدأ برنامجا
مكثفا لإنشاء المدارس.`
                : fr
                ? `Si l'étude de l'islam reste au cœur
                du système éducatif moderne,
                celui-ci offre également un
                enseignement de qualité dans
                divers domaines des arts et des
                sciences. Cette diversité aide tous
                les pays à préparer leurs citoyens à
                la vie et au travail dans une
                économie mondiale. Nous allons
                lancer un vaste programme visant à
                créer des écoles.`
                : `While the study of Islam remains at its core, the
                            modern educational system also provides quality
                            instruction in diverse fields of arts and sciences.
                            This diversity helps all countries prepare its
                            citizens for life and work in a global economy. We
                            will begin an extensive program to establish
                            schools.`}
            </p>
          </div>
          <div class="edu-card">
            <p>
              {rtl
                ? `وكان أحد الأهداف الأولى
للخطة هو إنشاء مدارس
ومؤسسات جديدة للتعليم
العالي في بعض بلدان
الشرق الأوسط وآسيا
وأفريقيا وتوسيع المدارس
القائمة.`
                : fr
                ? `L'un des premiers objectifs
                du plan était de créer de
                nouvelles écoles et
                institutions
                d'enseignement supérieur
                dans certains pays du
                Moyen-Orient, d'Asie et
                d'Afrique et d'agrandir
                celles qui existaient déjà.`
                : `One of the plan’s first objectives was to establish
                            new schools and institutions of higher education
                            throughout some middle east, Asia and African
                            countries and expand existing ones.`}
            </p>
          </div>
          <div class="edu-card">
            <p>
              {rtl
                ? `في القرون التي تلت ولادة
الإسلام، أنشأت الدول
الإسلامية مدارس وجامعات
ومكتبات فريدة من نوعها
في العالم. أصبح العالم
الإسلامي مركزا للتعلم،
حيث قدم مساهمات كبيرة
في مجالات علم الفلك
والفيزياء والفن والفلسفة
والطب وهي الفترة المعروفة
باسم "العصر الذهبي".`
                : fr
                ? `Dans les siècles qui ont suivi la
                naissance de l'islam, les États
                musulmans ont créé des écoles,
                des universités et des
                bibliothèques uniques au monde.
                Le monde islamique est devenu
                un centre d'apprentissage,
                apportant des contributions
                majeures dans les domaines de
                l'astronomie, de la physique, de
                l'art, de la philosophie et de la
                médecine - une période connue
                sous le nom d'"âge d'or".`
                : `In the centuries after the birth of Islam, Muslim
                            states established schools, universities and
                            libraries that were unique in the world. The Islamic
                            world became a center for learning, making major
                            contributions in the areas of astronomy, physics,
                            art, philosophy, and medicine – a period known as
                            the “Golden Age.”`}
            </p>
          </div>
          <div class="edu-card">
            <p>
              {rtl
                ? `أصبحت الأساليب التي
ابتكرها العلماء والعلماء
المسلمون خلال العصر
الذهبي أساس العلوم الحديثة
، وتم تدريسها في الجامعات
الأوروبية حتى القرن 18.`
                : fr
                ? `Les méthodes mises au point par
                les savants et les scientifiques
                musulmans durant l'âge d'or
                sont devenues le fondement des
                sciences modernes et ont été
                enseignées dans les universités
                européennes jusqu'au 18e
                siècle.`
                : ` Methods pioneered by Muslim scholars and scientists
                            during the Golden Age became the foundation of
                            modern sciences, and were taught in European
                            universities up to the 18th century.`}
            </p>
          </div>
        </div>
      </section>
      {/* <section
                class="u-section-2"
                style={{
                    position: "relative",
                    minHeight: "783px",
                    display: "flex",
                }}
            >
                <div
                    class="u-palette-1-base u-shape-1"
                    style={{
                        position: "absolute",
                        zIndex: -1,
                        backgroundColor: "rgb(203 163 52)",
                    }}
                ></div>
                <div class="middle-face">
                    <div class="u-face-one">
                        <span id="u-circle"></span>
                        <h1>Healthcare</h1>
                    </div>
                    <div>
                        <img
                            src={require("../../../Assets/images/charity-healthcare.jpg")}
                            alt="healthcare"
                            style={{ minHeight: "631px", width: "400px" }}
                        />
                    </div>
                    <div class="u-face-three">
                        <ul>
                            <li>
                                The establishment of a modern health care,
                                Medical Network and social services system will
                                be one of MMH most stunning successes.
                            </li>
                            <li>
                                In the beginning, the emphasis will be more on
                                establishing the necessary infrastructure of
                                hospitals, clinics, pharmacies, laboratories and
                                research facilities.
                            </li>
                            <li>
                                MMH will establish most of the health care
                                facilities throughout the African countries and
                                other countries. Our Islamic investment bank
                                will also encourage greater private sector
                                involvement by offering long-term, interest-free
                                loans for the establishment of hospitals,
                                clinics and pharmacies.
                            </li>
                            <li>
                                Our Holding companies will be also encouraged to
                                manufacture pharmaceuticals.
                            </li>
                            <li>
                                Another aspect of MMH social services network is
                                providing housing for the country’s
                                fast-growing, Health & Social Services,
                                Establishing a Modern Medical Network, Quality
                                Care accessible to All, Health Care Network,
                                Care for the Disabled and Housing Construction.
                            </li>
                            <li>
                                A particularly important policy has been to
                                provide interest-free, easy-term loans for home
                                construction to individuals and companies.
                            </li>
                        </ul>
                    </div>
                </div>
            </section> */}
      <section class="health">
        <h1>{rtl ? `الرعاية الطبية` : fr ? "SANTÉ" : `Healthcare`}</h1>

        <Healthcare />
      </section>
      <div class="container">
        <div class="plrs-wrap text-center remove-ext5">
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div class="col-md-3 col-sm-6 col-lg-2 plrs ">
              <Link to="/five-pillars-shahada">
                <div class="plr-box ">
                  <i class="flaticon-clicker"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الشهادتان` : `Shahadah`}</h4>
                    <p>({rtl ? `ايمان` : fr ? "La foi" : `Faith`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-prayer">
                <div class="plr-box">
                  <i class="flaticon-islamic-pray"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إقامِ الصلاةِ` : `Salah`}</h4>
                    <p>({rtl ? `صلاة` : fr ? "Prière" : `Prayer`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-fasting">
                <div class="plr-box">
                  <i class="flaticon-islamic-ramadan"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `صومِ رمضانَ` : `Sawm`}</h4>
                    <p>({rtl ? `صوم` : fr ? "Le jeûne" : `Fasting`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-zakat">
                <div class="plr-box">
                  <i class="flaticon-charity"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إيتاءِ الزّكاةِ` : `Zakat`}</h4>
                    <p>({rtl ? `الصدقة` : fr ? "L'aumône" : `Almsgiving`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 ">
              <Link to="/five-pillars-pilgrimage">
                <div class="plr-box">
                  <i class="flaticon-kaaba-building"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الحجِّ` : `Hajj`}</h4>
                    <p>({rtl ? `حج` : fr ? "Pèlerinage" : `Pilgrimage`})</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Zakat;
